var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 25,
    viewBox: "0 0 46 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70711 0.292893C1.31658 -0.0976311 0.683418 -0.0976311 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L1.70711 0.292893ZM21.9655 23.3797L22.6726 24.0868L24.0868 22.6726L23.3797 21.9655L21.9655 23.3797ZM0.292893 1.70711L21.9655 23.3797L23.3797 21.9655L1.70711 0.292893L0.292893 1.70711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5859 1.70512C45.9754 1.3135 45.9736 0.680338 45.582 0.290911C45.1903 -0.0985153 44.5572 -0.0967381 44.1678 0.294881L45.5859 1.70512ZM22.2909 22.2949L21.5858 23.004L23.004 24.4142L23.7091 23.7051L22.2909 22.2949ZM44.1678 0.294881L22.2909 22.2949L23.7091 23.7051L45.5859 1.70512L44.1678 0.294881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scrollDown.48cbc40cd124b03d13384d835e397fbf.svg";
export { ForwardRef as ReactComponent };